import React, { useEffect, useMemo, useState } from 'react';

import PreviewIcon from '@mui/icons-material/Preview';

import {
  OffCanvas,
  Table,
  useMessageDispatch,
} from 'itaf';
import AccessService from '../../../services/AccessService';

export default function ReportCanvas({ open, onCanvasClose, data }) {
  const [title, setTitle] = useState('');
  const [rows, setRows] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [progress, setProgress] = React.useState(0);

  const setMessageLocal = useMessageDispatch();
  function setMessage(message) {
    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage(message);
    }
  
    setMessageLocal(message);
  }

  useEffect(() => {
    setRows([]);
    if (data) {
      setTitle(`Listagem de acessos (${data.name})`);
      loadData();
    }
  }, [data]);

  function loadData() {
    if (data?.id) {
      setLoading(true);
      AccessService.getAccessByUserId(data.id)
        .then((response) => {
          setProgress(100);
          if (response.ok) {
            return response.json();
          }
          else {
            setMessage({ hasError: true, text: "Problema ao carregar relatório. Verifique conexão de internet." });
            return null;
          }
        })
        .then((result) => {
          if (result === null) {
            return;
          }

          setRows(result);
        })
        .catch ((error) => {
          console.log(error)
          setMessage({ hasError: true, text: "Problema ao carregar relatório. Tente atualizar a tela." });
        })
        .finally (() => {
          setLoading(false);
          setProgress(0);
        });
    }
  }

  const handleDrawerClose = () => {
    // setTimeout(() => { setMessage({ hasError: false, text: '' }); }, 10000);
    onCanvasClose(false);
  };

  const buildTable = () => {
    const columns = useMemo(
      () => [
        {
          header: "Evento", accessorKey: "event", //minSize: '70', size: '80', maxSize: '100',
          enableHiding: false, grow: true,
        },
        {
          header: "Data/Hora", accessorKey: "eventTime", size: 152,  grow: false,
          //enableColumnDragging: false,
          grow: true,
        },
      ],
      []
    );

    return (<Table
      title={'Acessos'}
      columns={columns}
      data={rows}
      isLoading={false}
      layoutMode="grid"
      positionToolbarAlertBanner="top"
      enableColumnResizing={true}
      enableGrouping={true}
      enablePagination={true}
      enablePinning={true}
      pagination
    />);
  };

  return (
    <OffCanvas
      closeLabel="Fechar"
      showPanel={open}
      onClosedPanel={handleDrawerClose}
      isLoading={isLoading}
      header={{ title: title, add: false, edit: false, icon: (<PreviewIcon />) }}
      progress={progress}
    >
      {buildTable()}
    </OffCanvas>
  );
};
